import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { PaginatedResponse } from 'services/api/types'

type MaxFreightDiscount = {
  paymentTermId: string
  maxDiscount: number
}

export const loadOrderMaxPaymentTermsDiscount =
  (): PaginatedResponse<MaxFreightDiscount> => {
    return axios.get(`orders/max-payment-terms-discount`)
  }

export function useLoadOrderMaxPaymentTermsDiscount() {
  return useQuery(
    ['orderMaxPaymentTermsDiscount'],
    loadOrderMaxPaymentTermsDiscount,
    {
      onError: () =>
        toast.error(
          'Não foi possível carregar a regra de desconto de pagamento!',
          {
            toastId: 'orderMaxPaymentTermsDiscount'
          }
        )
    }
  )
}
